import type { GameState } from './GameState';

export type TutorialSteg =
  | 'intro_vist'
  | 'innboks_vist'
  | 'kontrakt_klikket'
  | 'redigering_klikket'
  | 'forfatter_vist'
  | 'neste_dag_klikket'
  | 'fullfort';

const PREFIX = 'tut_';

export function flaggFor(steg: TutorialSteg): string {
  return `${PREFIX}${steg}`;
}

export function harSteg(state: GameState, steg: TutorialSteg): boolean {
  return state.harFlag(flaggFor(steg));
}

export function markerTutorialSteg(state: GameState, steg: TutorialSteg): void {
  state.settFlag(flaggFor(steg));
}

export function skipTutorial(state: GameState): void {
  state.settFlag(flaggFor('fullfort'));
}

export function tutorialFullfort(state: GameState): boolean {
  return state.harFlag(flaggFor('fullfort'));
}
